module.exports = __webpack_public_path__ + "prod/1.42.2/img/carService-chain.c289d120.png";